import { isActiveElement } from '../lib/dom.js';
import { findElementInEventPath } from '../lib/event.js';
import { unfocus } from './functions.js'; // for the `document` to delegate the events from outside the picker/input field

export function onClickOutside(datepicker, ev) {
  var element = datepicker.element,
      picker = datepicker.picker; // check both picker's and input's activeness to make updateOnBlur work in
  // the cases where...
  // - picker is hidden by ESC key press → input stays focused
  // - input is unfocused by closing mobile keyboard → piker is kept shown

  if (!picker.active && !isActiveElement(element)) {
    return;
  }

  var pickerElem = picker.element;

  if (findElementInEventPath(ev, function (el) {
    return el === element || el === pickerElem;
  })) {
    return;
  }

  unfocus(datepicker);
}